import { RestClient } from '@/api/rest-client'
import { RealworksKenmerk } from '@/api/model/realworks-kenmerk'

export class RealworksKenmerkClient extends RestClient<RealworksKenmerk> {
    collectionName = 'service/realworks/kenmerken'
    parseData = RealworksKenmerk.fromData
}
